import { render, staticRenderFns } from "./sy.vue?vue&type=template&id=35061ad7&scoped=true&"
import script from "./sy.vue?vue&type=script&lang=js&"
export * from "./sy.vue?vue&type=script&lang=js&"
import style0 from "./sy.vue?vue&type=style&index=0&id=35061ad7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35061ad7",
  null
  
)

export default component.exports